<template>
  <div>
    <Modal
      v-model="modalVisible"
      title="选择重派包裹"
      :mask-closable="false"
      width="85%"
      @on-visible-change="visibleChange"
    >
      <div class="zxtjcpc-redispatch-modal">
        <!-- 顶部信息 -->
        <div class="info_title">
          <div class="line_box">
            <div class="line_item">
              <span class="title">发货仓库：</span>
              <span>{{ warehouseName }}</span>
            </div>
          </div>
          <div class="line_box">
            <div class="line_item">
              <span class="title">收件国家/地区：</span>
              <span>{{ receivingCountry }}</span>
            </div>
            <div class="line_item">
              <span class="title">商品：</span>
              <span>{{ productInfo }}</span>
            </div>
          </div>
          <div class="line_box">
            <div class="line_item">
              <span class="title">预估重量(g)：</span>
              <span>{{ packInfo.totalWeight || '' }}</span>
            </div>
            <div class="line_item">
              <span class="title">预估尺寸(cm)：</span>
              <span>{{ packageSize }}</span>
            </div>
            <div class="line_item">
              <span class="title">预估体积(cm³)：</span>
              <span>{{ packageVolume }}</span>
            </div>
            <div class="line_item">
              <span class="title">预估周长(cm)：</span>
              <span>{{ packagePerimeter }}</span>
            </div>
          </div>
          <div class="line_box mt15">
            <Checkbox v-model="filterParams.suitable" @on-change="fetchList">只查看合适当前包裹重派的退件包裹</Checkbox>
          </div>
        </div>
        <!-- 筛选 -->
        <div class="filter-content mt15">
          <Form ref="filterFormRef" :model="filterParams" inline>
            <Form-item label="物流商" :label-width="60">
              <dyt-select v-model="filterParams.carrierId" placeholder="请选择物流商" clearable>
                <Option v-for="item in carrierList" :key="item.carrierId" :value="item.carrierId" :label="item.carrierName" />
              </dyt-select>
            </Form-item>
            <Form-item>
              <Button type="primary" icon="md-search" @click="fetchList" :loading="tableLoading">查询</Button>
            </Form-item>
          </Form>
        </div>
        <!-- 表格 -->
        <h3 class="commodity_title">物流相关设置：</h3>
        <Table
          border
          max-height="420"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData"
        />
      </div>
      <div slot="footer" style="padding: 20px 0 10px 0; text-align: center">
        <Button :loading="submitLoading" type="primary" @click="confirm">选择</Button>
        <Button @click="modalVisible = false">关闭</Button>
      </div>
      <Spin fix v-if="pageLoading"></Spin>
    </Modal>
  </div>
</template>

<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';

export default {
  name: 'ZxtjcpcRedispatchModal',
  mixins: [Mixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 当前包裹信息
    packInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // 已匹配的 matchInfo 信息
    matchInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // 订单详情
    orderDetailsData: {
      type: Object,
      default() {
        return {};
      }
    },
    // 仓库列表
    allStorelist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      modalVisible: false,
      tableLoading: false,
      submitLoading: false,
      pageLoading: false,
      tableData: [],
      carrierList: [],
      selectedRow: null,
      filterParams: {
        carrierId: null,
        suitable: true
      },
      tableColumns: [
        {
          title: '操作',
          key: 'operate',
          width: 80,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const checked = this.selectedRow && this.selectedRow.zxtjcpcReturnPackageId === row.zxtjcpcReturnPackageId;
            return h('Radio', {
              props: {
                value: checked
              },
              on: {
                'on-change': () => {
                  this.selectedRow = row;
                }
              }
            });
          }
        },
        {
          title: '物流商',
          key: 'carrierId',
          minWidth: 120,
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.carrierId)) return h('div', '');
            const findInfo = this.carrierList.find(f => f.carrierId);
            if (this.$common.isEmpty(findInfo)) return h('div', '');
            return h('div', findInfo.carrierName);
          }
        },
        { title: '原物流商单号', key: 'itemNo', minWidth: 150, align: 'center' },
        { title: '原跟踪号', key: 'logistics', minWidth: 150, align: 'center' },
        {
          title: '退件SKU及商品',
          key: 'goodsDetailList',
          minWidth: 180,
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.goodsDetailList)) return h('div', '');
            let tdItem = [];
            row.goodsDetailList.forEach(item => {
              tdItem.push(h('div', {}, `${item.sku} * ${item.quantity}`))
            });
            return h('div', {
              'display': 'inline-block',
              'text-align': 'left',
              'margin': '0 auto',
            }, tdItem);
          }
        },
        { title: '国家', key: 'originCountry', width: 100, align: 'center' },
        {
          title: '创建时间',
          key: 'createTime',
          width: 150,
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.createTime)) return h('div', '');
            const newTxt = this.$common.toLocaleDate(row.createTime, 'fulltime');
            if (this.$common.isEmpty(newTxt)) return h('div', row.createTime);
            return h('div', newTxt);
          }
        },
        {
          title: '到期时间',
          key: 'expireTime',
          width: 150,
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.expireTime)) return h('div', '');
            const newTxt = this.$common.toLocaleDate(row.expireTime, 'fulltime');
            if (this.$common.isEmpty(newTxt)) return h('div', row.expireTime);
            return h('div', newTxt);
          }
        }
      ]
    };
  },
  computed: {
    // 发货仓库名称
    warehouseName() {
      if (this.$common.isEmpty(this.packInfo.warehouseId) || this.$common.isEmpty(this.allStorelist)) return '';
      const warehouse = this.allStorelist.find(item => item.warehouseId === this.packInfo.warehouseId);
      return warehouse ? (warehouse.warehouseName || '') : '';
    },
    // 收件国家/地区
    receivingCountry() {
      return this.packInfo.buyerCountryCodeName || this.packInfo.buyerCountryCode || '';
    },
    // 商品信息
    productInfo() {
      const detailList = this.packInfo.orderShippingDetailList || [];
      if (this.$common.isEmpty(detailList)) return '';
      const firstItem = detailList[0] || {};
      const sku = firstItem.webstoreSku || firstItem.sku || '';
      const quantity = firstItem.quantity || 0;
      const total = detailList.reduce((sum, item) => sum + (item.quantity || 0), 0);
      if (detailList.length === 1) {
        return `${sku}*${quantity}`;
      }
      return `${sku}*${quantity} 等${total}件`;
    },
    // 预估尺寸
    packageSize() {
      const length = this.packInfo.length || '';
      const width = this.packInfo.width || '';
      const height = this.packInfo.height || '';
      if (length === '' && width === '' && height === '') return '';
      return `${length}*${width}*${height}`;
    },
    // 预估体积
    packageVolume() {
      const length = Number(this.packInfo.length || 0);
      const width = Number(this.packInfo.width || 0);
      const height = Number(this.packInfo.height || 0);
      if (!length || !width || !height) return '';
      return (length * width * height).toFixed(2);
    },
    // 预估周长
    packagePerimeter() {
      const length = Number(this.packInfo.length || 0);
      const width = Number(this.packInfo.width || 0);
      const height = Number(this.packInfo.height || 0);
      if (!length || !width || !height) return '';
      return (length + 2 * (width + height)).toFixed(2);
    },
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.modalVisible = val;
      }
    },
    modalVisible: {
      handler(val) {
        this.$emit('update:dialogVisible', val);
      }
    }
  },
  methods: {
    // 弹窗显示状态变化
    visibleChange(val) {
      if (!val) {
        this.selectedRow = null;
        this.tableData = [];
        this.filterParams.carrierId = null;
        this.filterParams.suitable = true;
        return;
      }
      this.$nextTick(() => {
        this.initData();
      });
    },
    // 初始化数据
    initData() {
      this.pageLoading = true;
      this.selectedRow = null;
      this.tableData = [];
      this.$common.promiseAll([
        this.getCarrierData,
      ]).finally(() => {
        this.pageLoading = false;
        this.fetchList();
      })
    },
    // 查询待重派包裹列表
    fetchList() {
      if (this.$common.isEmpty(this.packInfo.orderShippingId)) return;
      this.tableLoading = true;
      const params = {
        warehouseId: this.packInfo.warehouseId,
        carrierId: null,
        orderShippingId: null,
      };
      if (!this.$common.isEmpty(this.filterParams.carrierId)) {
        params.carrierId = this.filterParams.carrierId;
      }
      if (!this.$common.isEmpty(this.filterParams.suitable) && this.filterParams.suitable) {
        params.orderShippingId = this.packInfo.orderShippingId;
      }
      this.axios.post(api.post_zxtjcpcQueryWaitRedispatch, params).then(response => {
        if (response && response.data && response.data.code === 0) {
          this.tableData = response.data.datas || response.data.data || [];
        }
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    // 获取物流商数据（这里只要云途和出口易的物流商）
    getCarrierData () {
      this.carrierList = [];
      return new Promise((resolve, reject) => {
        this.axios.post(api.queryLogisticsChannel, {
          merchantId: '000035',
          isFilter: true,
          status: 1,
          more: true,
          shippingMethodStatus: 1
        }).then(res => {
          if (res.data.code === 0) {
            this.carrierList = (res.data.datas || []).filter(f => {
              return ['yuntu'].includes(f.carrierCode) || ['出口易货代'].includes(f.carrierName);
            });
            resolve({ status: true, data: res.data.datas });
            return;
          }
          resolve({ status: false, data: [] });
        }).catch(() => {
          resolve({ status: false, data: [] });
        })
      })
    },
    // 确认选择
    confirm() {
      if (this.$common.isEmpty(this.selectedRow)) {
        this.$Message.error('请选择重派包裹');
        return;
      }
      if (this.$common.isEmpty(this.selectedRow.zxtjcpcReturnPackageId)) {
        this.$Message.error('缺少退件包裹ID');
        return;
      }
      this.submitLoading = true;
      const params = {
        orderShippingId: this.packInfo.orderShippingId,
        zxtjcpcReturnPackageId: this.selectedRow.zxtjcpcReturnPackageId
      };
      this.axios.post(api.post_zxtjcpcUpdateMatch, params).then(response => {
        if (response && response.data && response.data.code === 0) {
          this.$Message.success('操作成功');
          this.$emit('confirmSuccess');
          this.modalVisible = false;
        } else {
          this.$Message.error(response.data && response.data.message ? response.data.message : '操作失败');
        }
      }).catch(() => {
        this.$Message.error('操作失败，请重新尝试');
      }).finally(() => {
        this.submitLoading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.zxtjcpc-redispatch-modal {
  .info_title {
    border-bottom: 1px dashed #797979;
    padding-bottom: 15px;
    .line_box {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .line_item {
        margin-right: 50px;
      }
      .title {
        font-weight: bold;
        color: #333;
      }
    }
  }
  .commodity_title {
    color: #333;
    font-size: 14px;
    font-weight: bold;
    margin: 15px 0 5px 0;
  }
  .filter-content {
    position: relative;
    :deep(.ivu-form) {
      .ivu-form-item {
        display: inline-block;
        margin-bottom: 0;
        .ivu-form-item-label {
          padding-right: 5px;
        }
      }
    }
  }
}
</style>
